import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import PopUpAlertStyles from '../styles/PopupAlert.module.css'; 

const PopupAlert = ({ open, buttonText, handleClose, message, title }) => {
  return (
    <Dialog 
      open={open} 
      onClose={handleClose}
      classes={{ paper: PopUpAlertStyles.dialogPaper }} 
    >
      <DialogTitle className={PopUpAlertStyles.dialogTitle}>
        {title}
      </DialogTitle>
      <DialogContent className={PopUpAlertStyles.dialogContent}>
        <p className={PopUpAlertStyles.message}>
          {message}
        </p>
      </DialogContent>
      <DialogActions className={PopUpAlertStyles.dialogActions}>
        <Button 
          onClick={handleClose} 
          variant="contained"
          className={PopUpAlertStyles.button}
        >
          {buttonText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PopupAlert;